import palette from '../palette';

export default {
    root: {
        color: palette.primary.main,
        marginBottom: '5px',
    },
};
